<template>
    <v-dialog persistent v-model="dialog" width=50%>
        <v-card class="px-2">
            <v-container>
                <!-- header info -->
                <v-row class="pa-4 pb-0">
                    <h3>Edit user info</h3>
                </v-row> 
                <v-row class="pa-4 pb-0">
                    <h5>{{ gebr_code }} : {{ gebr_naam }}</h5>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <v-text-field v-model="gebr.gebr_naam" label="Name" />
                    </v-col>
                    <v-col cols="6">
                        <v-text-field v-model="gebr.gebr_email" label="Email" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="4">
                        <v-text-field v-model="gebr.taal_code" label="Language" />
                    </v-col>
                    <v-col cols="4">
                        <v-text-field v-model="gebr.gebr_functie" label="Function" />
                    </v-col>
                    <v-col cols="4">
                        <v-switch v-model="gebr.gebr_actief" :label="`Active: ${gebr.gebr_actief.toString()}`" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <v-text-field v-model="gebr.gebr_indienst_dat" label="Employment date" />
                    </v-col>
                    <v-col cols="6">
                        <v-text-field v-model="gebr.gebr_uitdienst_dat" label="Termination date" />
                    </v-col>
                </v-row>
                <!--
                <v-row>
                    <v-col cols="6">
                        <v-text-field v-model="gebr.gebr_passwd" label="Password" />
                    </v-col>
                </v-row>
                
                <v-row>
                    <v-col cols="6">
                        <v-text-field v-model="gebr.bedr_codes_lees" label="Company read rights" />
                    </v-col>
                    <v-col cols="6">
                        <v-text-field v-model="gebr.bedr_codes_schrijf" label="Company write rights" />
                    </v-col>
                </v-row>
                -->
                <v-row>
                    <v-col cols="6">
                        <v-text-field v-model="gebr.gebr_type" label="User type" />
                    </v-col>
                    <v-col cols="6">
                        <v-text-field v-model="gebr.gebr_login_attempt" label="Login attempt" />
                    </v-col>
                </v-row>
                <!--
                <v-row>
                    <v-col cols="6">
                        <v-text-field v-model="gebr.gebr_url_foto" label="Photo URL" />
                    </v-col>
                    <v-col cols="6">
                        <v-text-field v-model="gebr.gebr_file_foto" label="Photo file" />
                    </v-col>
                </v-row>
                -->
                <v-row>
                    <v-col cols="6">
                        <v-text-field v-model="gebr.land_code" label="Country" />
                    </v-col>
                    <v-col cols="6">
                        <v-text-field v-model="gebr.gebr_code_binnendienst" label="User code internal service" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <v-text-field v-model="gebr.eign_code_agtn" label="Agent" />
                    </v-col>
                    <v-col cols="6">
                        <v-text-field v-model="gebr.eign_code_agtn_zonder_commissie" label="Agent without commission" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <v-text-field v-model="gebr.gebr_groep" label="User group" />
                    </v-col>
                    <v-col cols="6">
                        <v-text-field v-model="gebr.gebr_no_athenticator_until_date" label="no authenticator until date" />
                    </v-col>
                </v-row>
                <!--
                <v-row>
                    <v-col cols="6">
                        <v-text-field v-model="gebr.gebr_2fa_secret" label="2fa secret" />
                    </v-col>
                </v-row>
                -->
                <v-row class="pa-4 pb-2">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" class="pr-5" small v-on:click="saveSelect">Save</v-btn>
                    &nbsp;
                    <v-btn color="primary" small v-on:click="closeSelect">Close</v-btn> 
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: {
        },             
        data() {
            return {
                gebr_encrid: "",
                gebr_code: "",
                gebr_naam: "",
                search: "",
                all_tasks: [],
                selected_tasks: [],
                dialog: false,
                gebr: {},
            }
        },
        methods: {  
            getUserInfo() {
                this.$axios.post("ares/json/ares/syst/authorization/getUserInfo.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getUserInfo"
                    },
                    getUserInfo: {
                        gebr_encrid: this.gebr_encrid
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                        this.dialog = false;
                    } else {
                        this.gebr = res.data.getUserInfo;

                        this.selected_tasks = [];
                        for (let i = 0; i < this.all_tasks.length; i++) {
                            if (this.all_tasks[i].gebr_authorized) {
                                this.selected_tasks.push(this.all_tasks[i]);  
                            }           
                        }

                        this.dialog = true;
                    }
                });
            },    
            openSelect(user) {
                this.gebr_encrid = user.gebr_encrid;
                this.gebr_code = user.gebr_code;
                this.gebr_naam = user.gebr_naam;
                this.getUserInfo();
            },
            saveSelect() {
                let selection = [];
                for (let i = 0; i < this.selected_tasks.length; i++) {
                    selection.push(this.selected_tasks[i].taak_code);         
                }                
                this.$axios.post("ares/json/ares/syst/authorization/updUserInfo.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "updUserInfo"
                    },
                    updUserTaak: {
                        gebr_encrid: this.gebr_encrid,
                        selected_tasks: selection,
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        // Users updates, update parent & leave dialog
                        this.$emit("updateData"); 
                        this.dialog = false;
                    }
                });
            },
            closeSelect() {
                this.dialog = false;
            },
            getHeaders() {
                return [
                    { text: "Taak", value: "taak_code", sortable: true},
                    // { text: "Program(s)", value: "taak_prog", sortable: false},
                    { text: "Description", value: "taak_oms", sortable: false},
                ];
            },	            
        },
    }

</script>

<style scoped>
    .row-pointer {
      cursor: pointer;
    }
    .button-margin-lr{
        margin-left: 4px;
        margin-right: 4px;
    }
    .button-margin-l{
        margin-left: 4px;
    }  
    .button-margin-r{
        margin-right: 6px;
    }  
    .gridbutton:hover{
        border: 1px solid rgba(169, 169, 169, 1) !important;
    }

	.flex{
		display: flex;
		flex-direction: row;
		align-items: center;
	}
    .ul_style {
        list-style-type: none;
        /* Remove bullets */
        padding: 0;
        /* Remove padding */
        margin: 0;
        /* Remove margins */
        height: 315px;
        overflow-y: auto;
    }
</style>